import { Component, OnInit } from '@angular/core';
import { TempProductionService } from '@app/shared/services/temp-production.service';
import * as XLSX from 'xlsx';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-printing-week-res',
  templateUrl: './printing-week-res.component.html',
  styleUrls: ['./printing-week-res.component.css']
})
export class PrintingWeekResComponent implements OnInit {

  constructor(
    private tempProductionService: TempProductionService, private cdr: ChangeDetectorRef
  ) { }

  tempPrintingData: any[] = [];
  allTempPrintingData: any[] = [];
  paginatedTempPrintingData: any[] = [];

  currentPage: number = 1;
  itemsPerPage: number = 25;
  totalPages: number = 1;

  searchOperator: string = '';
  searchShift: string = '';
  searchMachine: string = '';
  searchClient: string = '';
  searchJobName: string = '';
  searchTicket: string = '';
  searchRefNo: string = '';
  searchFromDate: string = '';
  searchToDate: string = '';

  clientNames: string[] = [];
  shiftNames: string[] = [];
  machineNames: string[] = [];
  jobNames: string[] = [];
  ticketNumbers: string[] = [];
  refNumbers: string[] = [];
  operatorNames: string[] = [];

  ngOnInit(): void {
    this.loadTempPrintingData();
  }

  loadTempPrintingData(): void {
    this.tempProductionService.getTempPrinting().subscribe(
      (data) => {

        if (Array.isArray(data)) {

          this.allTempPrintingData = [...data].reverse();
          this.tempPrintingData = [...this.allTempPrintingData];

          this.totalPages = Math.ceil(
            this.tempPrintingData.length / this.itemsPerPage
          );

          this.updatePaginatedTempPrintingData();

          this.operatorNames = [
            ...new Set(
              this.tempPrintingData
                .map(x => x.operator)
                .filter(Boolean)
            )
          ];

          this.clientNames = [
            ...new Set(
              this.tempPrintingData
                .map(x => x.clientName)
                .filter(Boolean)
            )
          ];

          this.shiftNames = [
            ...new Set(
              this.tempPrintingData
                .map(x => x.shift)
                .filter(Boolean)
            )
          ];

          this.machineNames = [
            ...new Set(
              this.tempPrintingData
                .map(x => x.machine)
                .filter(Boolean)
            )
          ];

          this.jobNames = [
            ...new Set(
              this.tempPrintingData
                .map(x => x.jobName)
                .filter(Boolean)
            )
          ];

          this.ticketNumbers = [
            ...new Set(
              this.tempPrintingData
                .map(x => x.ticketNo)
                .filter(Boolean)
            )
          ];

          this.refNumbers = [
            ...new Set(
              this.tempPrintingData
                .map(x => x.refNo)
                .filter(Boolean)
            )
          ];
        }
      },
      (error) => {
        console.error('Error loading Temp Printing Data:', error);
      }
    );
  }

  updatePaginatedTempPrintingData(): void {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;

    this.paginatedTempPrintingData =
      this.tempPrintingData.slice(startIndex, endIndex);
  }

  goToPage(page: number): void {

    if (page < 1 || page > this.totalPages) {
      return;
    }

    this.currentPage = page;
    this.updatePaginatedTempPrintingData();
  }

  filterTable(): void {

    let filteredData = [...this.allTempPrintingData];

    if (this.searchOperator) {
      filteredData = filteredData.filter(entry =>
        (entry.operator || '')
          .toLowerCase()
          .includes(this.searchOperator.toLowerCase())
      );
    }

    if (this.searchShift) {
      filteredData = filteredData.filter(entry =>
        (entry.shift || '')
          .toLowerCase()
          .includes(this.searchShift.toLowerCase())
      );
    }

    if (this.searchMachine) {
      filteredData = filteredData.filter(entry =>
        (entry.machine || '')
          .toLowerCase()
          .includes(this.searchMachine.toLowerCase())
      );
    }

    if (this.searchClient) {
      filteredData = filteredData.filter(entry =>
        (entry.clientName || '')
          .toLowerCase()
          .includes(this.searchClient.toLowerCase())
      );
    }

    if (this.searchJobName) {
      filteredData = filteredData.filter(entry =>
        (entry.jobName || '')
          .toLowerCase()
          .includes(this.searchJobName.toLowerCase())
      );
    }

    if (this.searchTicket) {
      filteredData = filteredData.filter(entry =>
        (entry.ticketNo || '')
          .toLowerCase()
          .includes(this.searchTicket.toLowerCase())
      );
    }

    if (this.searchRefNo) {
      filteredData = filteredData.filter(entry =>
        (entry.refNo || '')
          .toLowerCase()
          .includes(this.searchRefNo.toLowerCase())
      );
    }

    if (this.searchFromDate) {
      filteredData = filteredData.filter(entry =>
        new Date(entry.date) >= new Date(this.searchFromDate)
      );
    }

    if (this.searchToDate) {
      filteredData = filteredData.filter(entry =>
        new Date(entry.date) <= new Date(this.searchToDate)
      );
    }

    this.tempPrintingData = filteredData;

    this.currentPage = 1;

    this.totalPages = Math.ceil(
      this.tempPrintingData.length / this.itemsPerPage
    );

    this.updatePaginatedTempPrintingData();

     // 🔥 FORCE UI UPDATE
    this.cdr.detectChanges();
  }

  clearFilters(): void {

    this.searchOperator = '';
    this.searchShift = '';
    this.searchMachine = '';
    this.searchClient = '';
    this.searchJobName = '';
    this.searchTicket = '';
    this.searchRefNo = '';
    this.searchFromDate = '';
    this.searchToDate = '';

    this.tempPrintingData = [...this.allTempPrintingData];

    this.currentPage = 1;

    this.totalPages = Math.ceil(
      this.tempPrintingData.length / this.itemsPerPage
    );

    this.updatePaginatedTempPrintingData();
  }

  getTotal(fieldName: string): number {
    return this.tempPrintingData.reduce((total, entry) => {
      return total + (parseFloat(entry[fieldName]) || 0);
    }, 0);
  }

  exportToExcel(): void {

    const worksheet: XLSX.WorkSheet =
      XLSX.utils.json_to_sheet(this.tempPrintingData);

    const workbook: XLSX.WorkBook =
      XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      'Printing Records'
    );

    XLSX.writeFile(
      workbook,
      'printing_records.xlsx'
    );
  }

}
